import {
  SHOPPER_AGENT_GUIDELINE_MAX_COUNT,
  SHOPPER_AGENT_GUIDELINE_MAX_LENGTH,
  ShopperAgentGuidelineTextSchema,
} from "@redotech/redo-shopper-agent-settings-common/guideline-config";
import * as z from "zod";

export const validateShopperAgentGuideline = {
  name: "validateShopperAgentGuideline" as const,
  input: z.object({
    /** Untrimmed, since the issues' offsets index into this text. */
    guideline: z.string().max(SHOPPER_AGENT_GUIDELINE_MAX_LENGTH),
    /** The rest of the list as currently edited, to catch contradictions. */
    otherGuidelines: z
      .array(ShopperAgentGuidelineTextSchema)
      .max(SHOPPER_AGENT_GUIDELINE_MAX_COUNT),
  }),
  output: z.object({
    issues: z.array(
      z.object({
        start: z.number().int(),
        end: z.number().int(),
        message: z.string(),
        kind: z.string().optional(),
      }),
    ),
  }),
};
